import { Controller, useFormContext } from 'react-hook-form'

import { DatePicker, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const ActionDate = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.actionDate`}
      control={control}
      render={({ field }) => <FF2 field={field} label="26. Action Date" input={(props) => <DatePicker {...props} />} />}
    />
  )
}
